import React from 'react';
import {ScrollView, View, StyleSheet} from 'react-native';
import BaseScreen from '../BaseScreen';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import {useSubsidyDetails} from 'src/hooks/useSubsidyDetails';
import {SubsidyCard} from './components/SubsidyCard';
import {SubsidyDetailRow} from './components/SubsidyDetailRow';
import AVText from '../../elements/AVText';
import {getLayoutDescriber} from '../../elements/layoutDescriptor/DescriptorType';
import {buildSubsidyDetailFields} from 'src/utils/subsidyUtils';
import {getSubsidyPageBackgroundColor} from 'src/utils/subsidyCardUtils';

const backgroundColor = getSubsidyPageBackgroundColor();

const SubsidiesScreen: React.FC = () => {
  const {subsidyDetails, isLoading} = useSubsidyDetails();

  const detailFields = subsidyDetails
    ? buildSubsidyDetailFields(subsidyDetails)
    : [];

  return (
    <BaseScreen
      title={Localized.Labels.subsidy}
      previousRoute={Localized.Labels.wallet}
      testId="qa_Subsidies_Page"
    >
      <View style={styles.contentWrapper}>
        {isLoading || !subsidyDetails ? (
          <View style={styles.centerContainer}>
            <AVText style={styles.errorText}>{Localized.Labels.loading}</AVText>
          </View>
        ) : (
          <ScrollView
            style={styles.scrollView}
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
          >
            <SubsidyCard subsidyDetails={subsidyDetails} />

            <View style={styles.detailsContainer}>
              {detailFields.map((field, index) => (
                <SubsidyDetailRow
                  key={field.key}
                  title={field.title}
                  value={field.value}
                  showSeparator={index < detailFields.length - 1}
                  testID={field.testID}
                />
              ))}
            </View>
          </ScrollView>
        )}
      </View>
    </BaseScreen>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    flex: 1,
    backgroundColor,
  },
  scrollView: {
    flex: 1,
    backgroundColor,
  },
  scrollContent: {
    paddingBottom: Styles.Spacing.m5,
    paddingTop: Styles.Spacing.m1,
  },
  detailsContainer: {
    marginHorizontal: Styles.Spacing.m3,
    marginTop: 24,
    paddingHorizontal: Styles.Spacing.m3,
  },
  centerContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: Styles.Spacing.m3,
    backgroundColor,
  },
  loadingText: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    color: Styles.darkColor,
    marginTop: Styles.Spacing.m2,
  },
  errorText: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    color: Styles.darkColor,
    textAlign: 'center',
  },
});

export default SubsidiesScreen;
